export interface EmailStatsData {
  processed: number;
  delivered: number;
  opened: number;
  clicked: number;
  bounced: number;
  deferred: number;
  dropped: number;
  spamreport: number;
  unsubscribed: number;
  resubscribed: number;
  unique_clicked: number;
  unique_opened: number;
}

export const emptyEmailStatsData = (): EmailStatsData => ({
  processed: 0,
  delivered: 0,
  opened: 0,
  clicked: 0,
  bounced: 0,
  deferred: 0,
  dropped: 0,
  spamreport: 0,
  unsubscribed: 0,
  resubscribed: 0,
  unique_clicked: 0,
  unique_opened: 0,
});

export const createEmailStatsData = <T extends Partial<EmailStatsData>>(initialValues: T): EmailStatsData & T => {
  return Object.assign(emptyEmailStatsData(), initialValues);
};

export interface DisplayLinkStats {
  url: string;
  displayUrl: string;
  totalClicks: number;
  uniqueClicks: number;
  displayClickRate: string;
}
